module.exports = __webpack_public_path__ + "b347eb5588bbb385cb71b11b847a15f0.mp4";